module.exports = __webpack_public_path__ + "img/1543154634.2fc336f8.jpg";